import { createContext, useContext } from "react";
import type { AxiosInstance } from "axios";

type PurchaseComponentsContextValue = {
  apiClient: AxiosInstance;
  partner: string;
  locale: string;
  contentful: {
    spaceId: string;
    accessToken: string;
    environment: string;
  };
};

export const PurchaseComponentsContext = createContext<PurchaseComponentsContextValue | null>(null);

export const usePurchaseComponents = (): PurchaseComponentsContextValue => {
  const context = useContext(PurchaseComponentsContext);
  if (!context) {
    throw new Error("usePurchaseComponents must be used within a <PurchaseComponentsProvider>");
  }
  return context;
};
